import {ReloadOutlined, SearchOutlined} from '@ant-design/icons/lib';
import {Button} from 'antd';
import {SearchBar} from 'components';
import {Formik, FormikHelpers} from 'formik';
import {Form, Input, Select} from 'formik-antd';
import {MASTER_ACCOUNT_FILTERS} from 'lib/enums';
import React from 'react';

type FilterValues = {
  filterName: string;
  filterValue: string;
};

export type FilterQueryParams = {
  [key: string]: any;
};

type Props = {
  onChange: (values: FilterQueryParams) => void;
  queryFilters: FilterQueryParams;
  availableFilters: Record<string, string>;
};

export const MasterAccountFilters: React.FC<Props> = ({
  onChange,
  queryFilters,
  availableFilters
}) => {
  const {...filters} = queryFilters;

  const initialValues: FilterValues = {
    filterName: 'name',
    filterValue: ''
  };

  const getInput = (filterName: string) => {
    const name = 'filterValue';
    return <Input name={name} allowClear />;
  };

  const handleSubmit = (
    {filterName, filterValue}: FilterValues,
    {resetForm}: FormikHelpers<typeof initialValues>
  ) => {
    const filter: FilterQueryParams = {...filters};
    if (filterValue !== '') filter[filterName] = filterValue;
    setTimeout(resetForm, 100);
    return onChange(filter);
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
      {({dirty, values}) => (
        <Form>
          <SearchBar compact>
            <Select
              name="filterName"
              style={{minWidth: 250}}
              showSearch
              optionFilterProp="children"
              listHeight={500}>
              {Object.entries(availableFilters).map(([value, label]) => {
                return (
                  <Select.Option key={value} value={value}>
                    {label}
                  </Select.Option>
                );
              })}
            </Select>
            {getInput(values.filterName)}
            <Button htmlType="submit" style={{minWidth: 130}} type={dirty ? 'primary' : undefined}>
              {dirty ? (
                <>
                  <SearchOutlined /> Search
                </>
              ) : (
                <>
                  <ReloadOutlined /> Refresh
                </>
              )}
            </Button>
          </SearchBar>
        </Form>
      )}
    </Formik>
  );
};
